import { lcConstants } from "@/apiUtils/constants";
import { AdditionalOptionsData, TranslationData } from "@/common/lib/types";
import RenderPrice from "@/components/productPrice/RenderPrice";
import Button from "@/components/ui/button/Button";
import Divider from "@/components/ui/divider/Divider";
import RenderCurrencyInText from "@/components/common/RenderCurrencyInText";
import { getPromotionBadgeNameFromPromotions } from "@/utils/promotionUtils";

interface IProps {
  lang: string;
  isMobile?: boolean;
  pricePrefix: string;
  currencyCode: string;
  onSelectOption: () => void;
  item: AdditionalOptionsData;
  translations: TranslationData;
}

const CardActions = (props: IProps) => {
  if (props.isMobile) {
    return (
      <div className="block bg-tertiary-3 pb-4 lg:hidden">
        <Divider containerClassName="mb-4" />
        <ActionContent {...props} />
      </div>
    );
  }

  return (
    <div className="hidden lg:block">
      <Divider containerClassName="mt-[0.625rem] mb-4" />
      <div className="mt-auto">
        <ActionContent {...props} />
      </div>
    </div>
  );
};

const ActionContent = ({
  item,
  lang,
  pricePrefix,
  currencyCode,
  translations,
  onSelectOption,
}: IProps) => {
  const promoBadgeName = getPromotionBadgeNameFromPromotions(item.availablePromotions, lang);

  return (
    <div className="flex items-center justify-between gap-4 px-4 md:justify-end lg:px-0">
      {item?.offerPrice ? (
        <div className="flex items-center gap-1">
          {item?.price && (
            <p className="text-[0.813rem] line-through">
              <RenderPrice price={item.price} currencyCode={currencyCode} lang={lang} />
            </p>
          )}
          {item?.offerPrice && (
            <p className="text-sm font-semibold text-secondary-1">
              <RenderPrice price={item.offerPrice} currencyCode={currencyCode} lang={lang} />
            </p>
          )}
          {/* TODO(QA): When Qatar (qa) is enabled, gate offerPercent with NEXT_PUBLIC_PERCENTAGE_SYMBOL_HIDE_COUNTRIES
              via getPercentHideCountries()/displayPercentage (same as Magrabi AdditionalOptionCard). */}
          {item?.offerPercent ? <p className="text-[0.813rem]">{item.offerPercent}</p> : ""}
          {promoBadgeName ? (
            <p className="text-sm font-semibold text-secondary-1">
              <RenderCurrencyInText text={promoBadgeName} />
            </p>
          ) : null}
        </div>
      ) : (
        <div className="product-price md">
          {item.price === lcConstants.INCLUDED ? (
            <p className="text-[0.813rem] font-bold">
              {translations?.lensConfigurator?.lens_config_include_label}
            </p>
          ) : (
            <p className="text-[0.813rem] font-bold">
              {pricePrefix} <RenderPrice price={item.price} currencyCode={currencyCode} lang={lang} />
            </p>
          )}
        </div>
      )}
      <Button onClick={onSelectOption} className="px-4 py-1 sm:px-4 sm:py-1 md:px-4 md:py-1">
        {
          translations?.lensConfigurator
            ?.lens_config_additional_options_section_add_to_cart_button_text
        }
      </Button>
    </div>
  );
};

export default CardActions;
